<a href="#main-content" class="skip-link">
    Skip to main content
</a>
<app-header tabindex="-1"></app-header>
<main id="main-content" tabindex="-1">
    <router-outlet (activate)="onActivate($event)"></router-outlet>
</main>
<app-footer></app-footer>
<div class="back_to_top_section" *ngIf="isShow" (click)="gotoTop()">
    <button title="Back to top">
        <svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M6 15L12 9L18 15" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
    </button>
</div>
<!-- <div class="cookiesSection" *ngIf="cookiesContainer">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="cookiesContent">
                    <p>We use cookies to offer you a personalized experience. By continuing to use this website, you consent to the use of cookies in accordance with our <a  [routerLink]="['/privacypolicy']">Cookie Policy.</a></p>
                    <div class="cookiesButtons">
                        <button (click)="setCookie()">Got it</button>
                        <button (click)="declineCookies()">Decline</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->

<!-- <div class="downtime-banner" *ngIf="downTimeBanner">
    <div class="downtime-inner">
        <button type="button" (click)="downTime()">
            <img src="../assets/icons/times.svg" alt="close" /> 
        </button>
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-9">
                    <p>Trinka will be unavaliable because of a system upgrade on Feburary 27, 2024, from 01:30 PM to 02:30 PM UTC. You may need to login again.</p>
                </div>
            </div>
        </div>
    </div>
</div> -->
